














































































































































































































































































































































































































































































































































































import Vue from 'vue'
import { chain } from 'lodash'

import WaitStep from './WaitStep.vue'
import CommonPost from './CommonPost.vue'

import Process from '@/components/workflow/Process.vue'
import Task from '@/components/workflow/Task.tsx'
import Timer from '@/components/workflow/Timer.tsx'

import { ProcessLog } from '@/store/workflow/types'

export default Vue.extend({
  components: {
    CommonPost,
    Process,
    Task,
    Timer,
    WaitStep,
  },
  computed: {
    currentCase(): any {
      return this.$store.getters.currentCase
    },
    treatmentProcesses(): ProcessLog[] {
      return chain(this.$store.getters['workflow/processLog'] as { [key: string]: ProcessLog })
        .values()
        .filter(
          p =>
            p.super_instance_id === (this as any).process.id &&
            p.business_key!.endsWith('-treatment')
        )
        .value()
    },
  },
  inject: {
    process: {
      default: null,
    },
  },
})
